var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLineReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.25V16.447L5.09233 14.1743L5.10753 14.1612C5.42289 13.8958 5.82186 13.7501 6.23409 13.75H18.5V2.25H2.5ZM1.01256 0.762563C1.34075 0.434375 1.78587 0.25 2.25 0.25H18.75C19.2141 0.25 19.6592 0.434374 19.9874 0.762563C20.3156 1.09075 20.5 1.53587 20.5 2V14C20.5 14.4641 20.3156 14.9092 19.9874 15.2374C19.6592 15.5656 19.2141 15.75 18.75 15.75H6.32889L3.39204 18.3248L3.37656 18.338C3.12167 18.5525 2.81088 18.6897 2.4807 18.7336C2.15052 18.7775 1.81466 18.7263 1.51259 18.5859C1.21052 18.4456 0.954777 18.2219 0.775409 17.9413C0.59604 17.6606 0.500496 17.3346 0.500001 17.0015L0.5 2C0.5 1.53587 0.684375 1.09075 1.01256 0.762563Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5C6.5 5.94772 6.94772 5.5 7.5 5.5H13.5C14.0523 5.5 14.5 5.94772 14.5 6.5C14.5 7.05228 14.0523 7.5 13.5 7.5H7.5C6.94772 7.5 6.5 7.05228 6.5 6.5Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 9.5C6.5 8.94771 6.94772 8.5 7.5 8.5H13.5C14.0523 8.5 14.5 8.94771 14.5 9.5C14.5 10.0523 14.0523 10.5 13.5 10.5H7.5C6.94772 10.5 6.5 10.0523 6.5 9.5Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineReview);
export default __webpack_public_path__ + "static/media/IconLineReview.c7b13810cd0cf7a9e841ab647beccdfd.svg";
export { ForwardRef as ReactComponent };